<template lang="html">
  <div v-if="state_login === 'T'">
    <!-- web -->
    <v-layout row wrap justify-center class="hidden-sm-and-down mt-5">
      <v-flex xs3 md3 sm3 lg3 md3 class="border-right">
        <v-layout column wrap justify-center align-center>
          <!-- <h1 class="mb-3">ข้อมูลส่วนตัว</h1> -->
          <v-avatar
            size="80"
          >
            <img v-if="profile_picture" :src="profile_picture" class="alligator-turtle">
            <img v-else src="/static/img/default_profile/man-white.png" class="alligator-turtle">
          </v-avatar>
          <h3 class="mt-3 text-transform-bot">{{name}}</h3>
          <h4 class="mt-3 text-transform-bot color-grey">{{status}}</h4>
          <h4 class="mt-1 color-grey">{{email}}</h4>
          <v-btn class="mt-2" color="primary" round outline small @click="logout()">ออกจากระบบ</v-btn>
        </v-layout>
        <v-divider class="mt-3"></v-divider>
        <v-layout row wrap class="height-listbot overflow-y" v-if="progress_listfriend">
           <v-progress-linear :indeterminate="progress_listfriend"></v-progress-linear>
        </v-layout>
        <v-layout row wrap class="height-listbot-friend overflow-y" v-else>
          <v-list three-line style="width: 100%;" dense v-if="list_friend_user.length !== 0">
            <template v-for="(item, index) in list_friend_user">
              <v-list-tile
                :key="item.tokenuser"
                avatar
              >
                <v-list-tile-avatar>
                  <img v-if="item.profilepicture" :src="item.profilepicture" class="alligator-turtle border-img">
                  <img v-else src="/static/img/default_profile/bot-white.png" class="alligator-turtle border-img">
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    <h4 class="text-transform-bot-friend">{{item.name}}</h4>
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    <span class="text-transform-bot-friend">{{item.status}}</span>
                    <br>
                    <span class="mt-3 fz-13 color-grey">เป็นเพื่อนกันเมื่อ : {{convert_date(item.timestamp_friend)}}</span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider
              v-if="index + 1 < list_friend_user.length"
              :key="index"
            ></v-divider>
            </template>
          </v-list>
          <h4 v-else class="mt-5 text-center">ไม่มีรายการเพื่อน</h4>
        </v-layout>
      </v-flex>
      <v-flex xs8 md8 sm8 lg8 md8>
        <h2 class="mb-3" style="text-align: center;">ค้นหาข้อมูล</h2>
        <v-layout row wrap justify-center align-center>
          <v-text-field
            name="name"
            v-model="search"
            label="กรุณากรอกชื่อผู้ใช้งานหรืออีเมลของบุคคลที่ต้องการค้นหา..."
            id="id"
            clearable
            solo
            dense
            hide-details
            prepend-inner-icon="search"
            @keyup.enter="search_friend()"
          ></v-text-field>
          <v-btn color="primary" round @click="search_friend()" :disabled="search === '' || search === null">ค้นหา</v-btn>
        </v-layout>
        <v-layout v-if="progress_seach" row wrap justify-center align-center class="height-listbot">
          <v-progress-circular :size="80" :width="4" color="primary" :indeterminate="progress_seach"></v-progress-circular>
        </v-layout>
        <v-layout column justify-center align-center v-else>
          <v-layout column justify-center align-center v-if="list_friend_serch.length === 0">
            <h3 class="mt-3">{{message_search}}</h3>
          </v-layout>
          <v-layout column justify-start align-start v-else style="width: 100%;">
            <v-flex xs12 sm12 md12 lg12 xl12 style="width: 100%;">
              <v-layout row wrap justify-center>
                <v-flex xs6 sm6 md6 lg6 xl6>
                  <h3 class="text-transform mt-5">ข้อมูลส่วนตัว</h3>
                  <v-layout column wrap justify-center align-center>
                    <v-avatar
                      size="70"
                      class="mt-3"
                    >
                      <img v-if="infor_friend_search.profilepicture" :src="infor_friend_search.profilepicture" alt="alt" class="alligator-turtle">
                      <img v-else src="/static/img/default_profile/man-white.png" class="alligator-turtle border-img">
                    </v-avatar>
                    <h4 class="text-transform-bot mt-2">{{infor_friend_search.nickname}}</h4>
                    <span class="color-grey text-transform-bot">{{infor_friend_search.status}}</span>
                    <span class="color-grey text-transform">{{infor_friend_search.email}}</span>
                  </v-layout>
                </v-flex>
                <v-flex xs6 sm6 md6 lg6 xl6 v-if="list_infor_business.length !== 0">
                  <h3 class="text-transform mt-5">ข้อมูลองค์กร</h3>
                  <div style="margin-top: 10px; margin-left: 10px; width: 400px; overflow-x: scroll; overflow-y: hidden; display: -webkit-inline-box; background: none;">
                    <div v-for="(infor, index) in list_infor_business" class="mb-4">
                      <v-card style="border-radius: 20px; width: 200px; margin-right: 10px;">
                        <v-layout column wrap align-center justify-start style="height: 170px;">
                          <v-avatar
                            size="50"
                            class="mt-3"
                          >
                            <img v-if="infor.business_pic" :src="infor.business_pic" alt="alt" class="alligator-turtle">
                            <img v-else src="/static/img/default_profile/business-white.png" class="alligator-turtle border-img">
                          </v-avatar>
                          <h4 class="text-transform-bot mt-2">บริษัท : {{infor.business_name}}</h4>
                          <span class="mt-2 color-grey text-transform-bot">ตำแหน่ง : {{infor.role_name}}</span>
                        </v-layout>
                      </v-card>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 sm12 md12 lg12 xl12>
              <v-layout row wrap>
                <span class="mt-2">รายชื่อบอทที่เป็นเพื่อนกับ </span><h4 class="text-transform mt-2 ml-2">{{infor_friend_search.nickname}}</h4>
              </v-layout>
              <v-layout row wrap class="height-listbot overflow-y mt-3">
                <v-flex
                  v-for="(item, index) in list_friend_serch"
                  :key="item.tokenuser"
                  xs6
                  d-flex
                  class="mt-2 mb-3 pl-3"
                >
                <v-card class="d-flex" style="min-height: 90px; border-radius: 20px; min-width: 300px; margin-right: 10px;">
                  <v-layout row wrap justify-center>
                    <v-flex xs2 sm2 md2 lg2 xl2 class="pl-3">
                      <v-avatar
                        size="50"
                        class="mt-3"
                      >
                        <img v-if="item.profilepicture" :src="item.profilepicture" alt="alt" class="alligator-turtle">
                        <img v-else src="/static/img/default_profile/bot-white.png" class="alligator-turtle border-img">
                      </v-avatar>
                    </v-flex>
                    <v-flex xs10 sm10 md10 lg10 xl10 class="pl-4">
                      <v-layout column wrap justify-start align-start>
                        <h4 class="text-transform mt-2">{{item.name}}</h4>
                        <span class="color-grey text-transform">{{item.status}}</span>
                        <span class="mt-1 color-grey text-transform">เป็นเพื่อนกันเมื่อ : {{convert_date(item.timestamp_friend)}}</span>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-card>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- mobile -->
    <v-layout row wrap justify-start class="hidden-md-and-up">
      <v-navigation-drawer
        app
        v-model="drawer"
        :mini-variant.sync="mini"
        stateless
      >
        <v-toolbar flat class="transparent" style="height: 220px;">
          <v-list class="pa-0">
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <v-btn @click.stop="mini = !mini" flat icon color="primary">
                  <v-icon>{{mini ? 'fas fa-chevron-left' : 'fas fa-chevron-right'}}</v-icon>
                </v-btn>
              </v-list-tile-avatar>
            </v-list-tile>
          </v-list>
          <v-layout column wrap justify-center align-center class="mt-3">
            <v-avatar
              size="50"
            >
              <img v-if="profile_picture" :src="profile_picture" class="alligator-turtle">
              <img v-else src="/static/img/default_profile/man-white.png" class="alligator-turtle">
            </v-avatar>
            <h3 class="mt-3 text-transform-bot">{{name}}</h3>
            <h4 class="mt-3 text-transform-bot color-grey">{{status}}</h4>
            <h4 class="mt-1 color-grey">{{email}}</h4>
            <v-btn class="mt-2" color="primary" round outline small @click="logout()">ออกจากระบบ</v-btn>
          </v-layout>
        </v-toolbar>
        <v-list v-if="list_friend_user.length !== 0" class="pt-0 height-listbot-friend-mobile overflow-y" three-line style="width: 100%;" dense>
          <v-divider></v-divider>
          <template v-for="(item, index) in list_friend_user">
            <v-list-tile
              :key="item.tokenuser"
              avatar
            >
              <v-list-tile-content>
                <v-layout row wrap justify-center>
                  <v-flex xs2 sm2 md2 lg2 xl2 >
                    <v-avatar
                      size="50"
                      class="mt-3"
                    >
                      <img v-if="item.profilepicture" :src="item.profilepicture" alt="alt" class="alligator-turtle">
                      <img v-else src="/static/img/default_profile/bot-white.png" class="alligator-turtle border-img">
                    </v-avatar>
                  </v-flex>
                  <v-flex xs10 sm10 md10 lg10 xl10 class="pl-4">
                    <v-layout column wrap justify-start align-start>
                      <h4 class="text-transform mt-2">{{item.name}}</h4>
                      <span class="color-grey text-transform">{{item.status}}</span>
                      <span class="mt-1 color-grey text-transform">เป็นเพื่อนกันเมื่อ : {{convert_date(item.timestamp_friend)}}</span>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-divider
            v-if="index + 1 < list_friend_user.length"
            :key="index"
          ></v-divider>
          </template>
        </v-list>
        <h4 v-else class="mt-5 text-center">ไม่มีรายการเพื่อน</h4>
      </v-navigation-drawer>
      <v-content>
        <v-flex xs12 md12 sm12 lg12 md12 class="mt-1 ml-2">
          <h2 class="mb-3" style="text-align: center;">ค้นหาข้อมูล</h2>
          <v-layout row wrap justify-center align-center>
            <v-text-field
              name="name"
              v-model="search"
              label="กรุณากรอกชื่อผู้ใช้งานหรืออีเมลของบุคคลที่ต้องการค้นหา..."
              id="id"
              clearable
              solo
              dense
              hide-details
              prepend-inner-icon="search"
              @keyup.enter="search_friend()"
            ></v-text-field>
            <v-btn color="primary" round @click="search_friend()" :disabled="search === '' || search === null">ค้นหา</v-btn>
          </v-layout>
          <v-layout v-if="progress_seach" row wrap justify-center align-center class="height-listbot">
            <v-progress-circular :size="80" :width="4" color="primary" :indeterminate="progress_seach"></v-progress-circular>
          </v-layout>
          <v-layout column justify-center align-center v-else>
            <v-layout column justify-center align-center v-if="list_friend_serch.length === 0">
              <h3 class="mt-3">{{message_search}}</h3>
            </v-layout>
            <v-layout column justify-start align-start v-else style="width: 100%;">
              <v-flex xs12 sm12 md12 lg12 xl12 style="width: 100%;">
                <h3 class="text-transform mt-1">ข้อมูลส่วนตัว</h3>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-layout column wrap justify-center align-center>
                      <v-avatar
                        size="70"
                        class="mt-3"
                      >
                        <img v-if="infor_friend_search.profilepicture" :src="infor_friend_search.profilepicture" alt="alt" class="alligator-turtle">
                        <img v-else src="/static/img/default_profile/man-white.png" class="alligator-turtle border-img">
                      </v-avatar>
                      <h4 class="text-transform-bot mt-2">{{infor_friend_search.nickname}}</h4>
                      <span class="color-grey text-transform-bot">{{infor_friend_search.status}}</span>
                      <span class="color-grey text-transform">{{infor_friend_search.email}}</span>
                      <v-btn v-if="list_infor_business.length !== 0" @click="opendialog" class="mt-2" color="primary" small round outline>ข้อมูลองค์กร</v-btn>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <!-- <h4 class="text-transform-bot mt-2">รายชื่อบอทที่เป็นเพื่อนกับ {{infor_friend_search.nickname}}</h4> -->
                <v-layout row wrap>
                  <span class="mt-2">รายชื่อบอทที่เป็นเพื่อนกับ</span><h4 class="text-transform mt-2 ml-2">{{infor_friend_search.nickname}}</h4>
                </v-layout>
                <v-layout row wrap class="height-listbot overflow-y mt-3">
                  <v-flex
                    v-for="(item, index) in list_friend_serch"
                    :key="item.tokenuser"
                    xs12
                    d-flex
                    class="mt-2 mb-3 pl-3"
                  >
                  <v-card class="d-flex" style="min-height: 90px; border-radius: 20px; width: 200px; margin-right: 10px;">
                    <v-layout row wrap justify-center>
                      <v-flex xs2 sm2 md2 lg2 xl2 class="pl-3">
                        <v-avatar
                          size="50"
                          class="mt-3"
                        >
                          <img v-if="item.profilepicture" :src="item.profilepicture" alt="alt" class="alligator-turtle">
                          <img v-else src="/static/img/default_profile/bot-white.png" class="alligator-turtle border-img">
                        </v-avatar>
                      </v-flex>
                      <v-flex xs10 sm10 md10 lg10 xl10 class="pl-4">
                        <v-layout column wrap justify-start align-start>
                          <h4 class="text-transform mt-2">{{item.name}}</h4>
                          <span class="color-grey text-transform">{{item.status}}</span>
                          <span class="mt-1 color-grey text-transform">เป็นเพื่อนกันเมื่อ : {{convert_date(item.timestamp_friend)}}</span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-layout>
        </v-flex>
      </v-content>
    </v-layout>
    <v-dialog
      v-model="dialog"
      max-width="500"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title class="mt-2">ข้อมูลองค์กร</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closedialog">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <!-- mobile -->
          <div style="margin-left:10px; width: 200px; overflow-x: scroll; overflow-y: hidden; display: -webkit-inline-box; background: none;">
            <div v-for="(infor, index) in list_infor_business" class="mb-4">
              <v-card style="border-radius: 20px; width: 200px; margin-right: 10px;">
                <v-layout column wrap align-center justify-start style="height: 170px;">
                  <v-avatar
                    size="50"
                    class="mt-3"
                  >
                    <img v-if="infor.business_pic" :src="infor.business_pic" alt="alt" class="alligator-turtle">
                    <img v-else src="/static/img/default_profile/business-white.png" class="alligator-turtle border-img">
                  </v-avatar>
                  <h4 class="text-transform-bot mt-2">บริษัท : {{infor.business_name}}</h4>
                  <span class="mt-2 color-grey text-transform-bot">ตำแหน่ง : {{infor.role_name}}</span>
                </v-layout>
              </v-card>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="closedialog"
          >
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Momenttime } from '@/services'
export default {
  data () {
    return {
      dialog: false,
      drawer: true,
      mini: true,
      right: null,
      profile_picture: '',
      name: '',
      email: '',
      phone: '',
      status: '',
      state_login: '',
      list_friend_user: [],
      list_friend_serch: [],
      list_infor_business: [],
      infor_business: [],
      progress_listfriend: false,
      progress_seach: false,
      search: '',
      infor_friend_search: {},
      message_search: '',
      list_bot_filter: [
        'B54284b8db2e75aa8ab646dec485ddb97',
        'Bc2483eb3c24457c189cfd6c26b7dd511',
        'Bbc41524dcbc3515ebc3cfd36a1b4ac81',
        'B8c7ab7357ed5506eade2e932cb0e2102',
        'B8bb8493bce765ca99374070aefd167cb',
        'B183c8cc3eab55d6aa54e003b68c3f205',
        'B2e44b62af2985c548ccca79d0bce8e71',
        'Bc651b9fbc93a5adeabc0b2b643447f0e',
        'Beb7ed25c5c2058f9b6fb397c2e8873a9',
        'B2e29e6bb3dac51e2b6c5cfcf55002ff6',
        'B3ac5bf6f32465bde99216952701ac327',
        'B4540aaecd0e95ac3b568a1606001ceaf',
        'B0f97ea8eebb95f68a2cb641b695097b7',
        'Bf575c15407015ca1888aa2209db033ab',
        'B4f7385bc7ee356c89f3560795eeb8067',
        'B862cf51869e05d158dad18b63ac466bf',
        'Bb22876be9b195cfe87294be0f4c42bfa',
        'Bcff6cb4e22e75e49aa2a72da6f98523e',
        'Bb50c0737947e5e91b9fb035f535e46f8'
      ],
      list_bot_filter_dev: [
        'B99032998bace587e9652badd46b758c2',
        'B150e5db5d81a51d29f34b95f21804b50',
        'B82a3f1373a005621b175e38aca401708',
        'Beed8d2a1ce8a5cdc94d46f986598b9ce'
      ]
    }
  },
  mounted () {
    if (this.state_login === 'T') {
      this.$router.push('/relation/friend')
    } else {
      this.$router.push('/relation')
    }
  },
  created () {
    this.state_login = localStorage.getItem('state_login')
    this.profile_picture = localStorage.getItem('profilepicture')
    this.name = localStorage.getItem('name')
    this.phone = localStorage.getItem('phone')
    this.email = localStorage.getItem('email')
    this.status = localStorage.getItem('status')
    this.get_list_friend_user(this.email)
  },
  watch: {
    search () {
      if (this.search === '' || this.search === null) {
        this.list_friend_serch = []
        this.message_search = ''
      }
    }
  },
  methods: {
    closedialog () {
      this.infor_business = []
      this.dialog = false
    },
    opendialog () {
      this.infor_business = this.list_infor_business
      this.dialog = true
    },
    logout () {
      localStorage.removeItem('state_login')
      this.$router.push('/relation')
    },
    get_list_friend_user (email) {
      this.progress_listfriend = true
      this.axios.post(process.env.APImanage + '/listbotfriend', {
        key: email
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.progress_listfriend = false
          if (process.env.NODE_ENV === 'production') {
            var list_filter = []
            list_filter = _.filter(response.data.listfriend, function(o) {
              return o.tokenuser === 'B54284b8db2e75aa8ab646dec485ddb97' ||
                     o.tokenuser === 'Bc2483eb3c24457c189cfd6c26b7dd511' ||
                     o.tokenuser === 'Bbc41524dcbc3515ebc3cfd36a1b4ac81' ||
                     o.tokenuser === 'B8c7ab7357ed5506eade2e932cb0e2102' ||
                     o.tokenuser === 'B8bb8493bce765ca99374070aefd167cb' ||
                     o.tokenuser === 'B183c8cc3eab55d6aa54e003b68c3f205' ||
                     o.tokenuser === 'B2e44b62af2985c548ccca79d0bce8e71' ||
                     o.tokenuser === 'Bc651b9fbc93a5adeabc0b2b643447f0e' ||
                     o.tokenuser === 'Beb7ed25c5c2058f9b6fb397c2e8873a9' ||
                     o.tokenuser === 'B2e29e6bb3dac51e2b6c5cfcf55002ff6' ||
                     o.tokenuser === 'B3ac5bf6f32465bde99216952701ac327' ||
                     o.tokenuser === 'B4540aaecd0e95ac3b568a1606001ceaf' ||
                     o.tokenuser === 'B0f97ea8eebb95f68a2cb641b695097b7' ||
                     o.tokenuser === 'Bf575c15407015ca1888aa2209db033ab' ||
                     o.tokenuser === 'B4f7385bc7ee356c89f3560795eeb8067' ||
                     o.tokenuser === 'B862cf51869e05d158dad18b63ac466bf' ||
                     o.tokenuser === 'Bb22876be9b195cfe87294be0f4c42bfa' ||
                     o.tokenuser === 'Bcff6cb4e22e75e49aa2a72da6f98523e' ||
                     o.tokenuser === 'Bb50c0737947e5e91b9fb035f535e46f8'
            })
            // console.log(list_filter)
            this.list_friend_user = list_filter
          } else {
            // list_filter = _.filter(response.data.listfriend, function(o) {
            //   return o.tokenuser === 'B99032998bace587e9652badd46b758c2' ||
            //          o.tokenuser === 'B150e5db5d81a51d29f34b95f21804b50' ||
            //          o.tokenuser === 'B82a3f1373a005621b175e38aca401708' ||
            //          o.tokenuser === 'Beed8d2a1ce8a5cdc94d46f986598b9ce'
            // })
            // console.log(list_filter)
            this.list_friend_user = response.data.listfriend
            // this.list_friend_user = []
          }
          this.list_infor_business = response.data.user_business
        }
      }).catch(error => {
        this.progress_listfriend = false
        console.log(error)
      })
    },
    search_friend () {
      this.progress_seach= true
      this.axios.post(process.env.APImanage + '/listbotfriend', {
        key: this.search
      }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.progress_seach= false
          // this.list_friend_serch = response.data.listfriend
          if (process.env.NODE_ENV === 'production') {
            var list_filter = []
            list_filter = _.filter(response.data.listfriend, function(o) {
              return o.tokenuser === 'B54284b8db2e75aa8ab646dec485ddb97' ||
                     o.tokenuser === 'Bc2483eb3c24457c189cfd6c26b7dd511' ||
                     o.tokenuser === 'Bbc41524dcbc3515ebc3cfd36a1b4ac81' ||
                     o.tokenuser === 'B8c7ab7357ed5506eade2e932cb0e2102' ||
                     o.tokenuser === 'B8bb8493bce765ca99374070aefd167cb' ||
                     o.tokenuser === 'B183c8cc3eab55d6aa54e003b68c3f205' ||
                     o.tokenuser === 'B2e44b62af2985c548ccca79d0bce8e71' ||
                     o.tokenuser === 'Bc651b9fbc93a5adeabc0b2b643447f0e' ||
                     o.tokenuser === 'Beb7ed25c5c2058f9b6fb397c2e8873a9' ||
                     o.tokenuser === 'B2e29e6bb3dac51e2b6c5cfcf55002ff6' ||
                     o.tokenuser === 'B3ac5bf6f32465bde99216952701ac327' ||
                     o.tokenuser === 'B4540aaecd0e95ac3b568a1606001ceaf' ||
                     o.tokenuser === 'B0f97ea8eebb95f68a2cb641b695097b7' ||
                     o.tokenuser === 'Bf575c15407015ca1888aa2209db033ab' ||
                     o.tokenuser === 'B4f7385bc7ee356c89f3560795eeb8067' ||
                     o.tokenuser === 'B862cf51869e05d158dad18b63ac466bf' ||
                     o.tokenuser === 'Bb22876be9b195cfe87294be0f4c42bfa' ||
                     o.tokenuser === 'Bcff6cb4e22e75e49aa2a72da6f98523e' ||
                     o.tokenuser === 'Bb50c0737947e5e91b9fb035f535e46f8'
            })
            this.list_friend_serch = list_filter
          } else {
            // list_filter = _.filter(response.data.listfriend, function(o) { return o.tokenuser === me.list_bot_filter_dev })
            // console.log(list_filter)
            // list_filter = _.filter(response.data.listfriend, function(o) {
            //   return o.tokenuser === 'B99032998bace587e9652badd46b758c2' ||
            //          o.tokenuser === 'B150e5db5d81a51d29f34b95f21804b50' ||
            //          o.tokenuser === 'B82a3f1373a005621b175e38aca401708' ||
            //          o.tokenuser === 'Beed8d2a1ce8a5cdc94d46f986598b9ce'
            // })
            // this.list_friend_serch = list_filter
            this.list_friend_serch = response.data.listfriend
          }
          this.infor_friend_search = response.data.user_data
          this.list_infor_business = response.data.user_business
        } else if (response.data.message === 'user not found') {
          this.progress_seach = false
          this.message_search = 'ไม่พบชื่อผู้ใช้งานหรืออีเมลนี้ในระบบ กรุณาตรวจสอบข้อมูลให้ถูกต้อง.'
        }
      }).catch(error => {
        this.progress_seach = false
        console.log(error)
      })
    },
    convert_date (date) {
      return Momenttime.momentdatethai(date)
    }
  }
}
</script>

<style lang="css" scoped>
.text-center {
  text-align: center;
  width: 100%;
}
.border-right {
  border-right-style: solid;
  border-right-width: thin;
  margin-right: 40px;
}
.height-listbot {
  height: calc(100vh - 500px);
}
.height-listbot-friend {
  height: calc(100vh - 300px);
}
.height-listbot-friend-mobile {
  height: calc(100vh - 220px);
}
.height-100vh {
  height: 100vh;
}
.overflow-y {
  overflow-y: scroll;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.color-grey {
  color: grey;
}
.text-transform {
  text-transform: none;
}
.border-img {
  border-style: solid;
  border-color: #8080805c;
  border-width: thin;
}
.text-transform-bot {
  text-transform: none;
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: center;
}
.text-transform-bot-friend {
  text-transform: none;
  width: 180px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.fz-13 {
  font-size: 13px;
}
>>>.v-text-field.v-text-field--enclosed {
  margin: 0;
  padding: 0;
  border-radius: 40px;
  border-style: solid;
  border-width: thin;
  border-color: grey;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  border-radius: 40px;
}
>>>.v-toolbar__content {
  height: 200px;
  justify-content: start;
  display: flex;
  align-items: self-end;
}
>>>.v-navigation-drawer {
  transition: none;
  display: block;
  left: 0;
  max-width: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  pointer-events: auto;
  top: 0;
  will-change: transform;
  z-index: 3;
  -webkit-overflow-scrolling: touch;
}
</style>



// WEBPACK FOOTER //
// src/components/homepage/Relation_friend.vue